import to_approve from './components/to_approve';
import to_pay from './components/to_pay';
import payout_history from './components/payout_history';

export default {
  to_approve,
  to_pay,
  payout_history,
};
